import styled from 'styled-components';
import { rem } from 'polished';
import Modal from '../../core/Modal';
import { Checkbox } from '../../core/Checkbox';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledCheckbox = styled(Checkbox)`
  margin-right: ${rem('20px')};
  label {
    font-size: ${rem('13px')};
    margin-left: ${rem('10px')};
    line-height: ${rem('19px')};
  }
  :checked ~ {
    background-color: #ffffff;
  }
`;

const StyledDataFormUser = styled.div`
  margin: 0 auto ${rem('50px')} auto;
  padding-left: ${rem('24px')};
  padding-right: ${rem('26px')};
  padding-top: ${rem('30px')};
  ${mediaqueries.lessThan('mobile')`
    padding-left: ${rem('15px')};
    padding-right: ${rem('15px')};
    padding-top: ${rem('25px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('947px')};
    padding-left:0;
    padding-right:0;
  `};
  .form-logo {
    display: flex;
    max-width: ${rem('200px')};
    margin: 0 auto ${rem('20px')};
  }
  .form-logo-txt {
    width: ${rem('400px')};
  }
  .form-logo-img {
    width: ${rem('200px')};
  }
  .form-saludo {
    text-align: center;
    margin-bottom: ${rem('40px')};
  }
  .form-box {
    background-color: #f3f3f3;
    padding: ${rem('10px')} ${rem('15px')};
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: ${rem('10px')};
    flex-direction: column;
    ${mediaqueries.greaterThan('tablet')`
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
    `};
    &.form-box--start {
      align-items: flex-start;

      .form-label {
        margin-top: ${rem('12px')};
      }
    }
  }
  .wrapped-campo {
    width: 100%;
    max-width: ${rem('368px')};
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.hide {
      display: none;
    }
    &:first-of-type {
      .form-btn-plus {
        margin-right: ${rem('8px')};
      }
    }

    &.wrapped-campo--tlf {
      justify-content: flex-end;

      .form-icon-lapiz {
        margin-left: ${rem('10px')};
      }
      .form-input {
        max-width: ${rem('230px')};
      }
    }
  }
  .txt-campo {
    flex-grow: 1;
  }
  .wrapped-campo-vertical {
    width: 100%;
    max-width: ${rem('368px')};
    display: flex;
    flex-direction: column;
    .wrapped-campo {
      margin-top: 10px;
      &:first-child {
        margin-top: 0;
      }
    }
  }
  .form-input,
  .form-dropdown,
  .form-input-date {
    max-width: ${rem('305px')};
    width: 100%;
    margin-right: ${rem('5px')};
  }
  .form-input-date {
    background-color: #fff;
  }
  .form-label {
    font-family: ${props => props.theme.fonts.book};
    margin-bottom: ${rem('5px')};
    margin-right: ${rem('50px')};
    ${mediaqueries.greaterThan('desktop')`
      font-size: ${rem('15px')};
      margin-bottom: 0;
    `};
  }
  .form-obligatorio {
    font-size: ${rem('30px')};
    display: flex;
    align-items: center;
    position: relative;
    top: ${rem('4px')};
    min-width: ${rem('12px')};
  }
  .form-publico {
    font-family: ${props => props.theme.fonts.bold};
    font-size: ${rem('15px')};
    display: flex;
    align-items: center;
    position: relative;
    min-width: ${rem('10px')};
  }
  .form-btn {
    margin-right: ${rem('5px')};
    border: none;
    outline: none;
  }
  .form-icon {
    width: ${rem('28px')};
    height: ${rem('28px')};
  }
  .form-footer {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }
  .form-btn-plus {
    width: ${rem('36px')};
    height: ${rem('36px')};
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: ${rem('20px')};
  }
  .form-icon-plus {
    width: ${rem('18px')};
    height: ${rem('18px')};
    fill: #fff;
    margin-right: 0;
  }
`;

const StyledFormModal = styled(Modal)`
  .wrapper-modal {
    max-width: ${rem('400px')};
    padding-top: ${rem('40px')};
  }
  .modal-buttons {
    padding-top: ${rem('40px')};
    display: flex;
    margin: 0 auto;
    width: ${rem('253px')};
    button:first-of-type {
      margin-right: ${rem('10px')};
    }
  }
  .form-dropdown,
  .form-otros {
    margin-bottom: ${rem('20px')};
  }
  .form-label {
    margin-bottom: ${rem('10px')};
  }
  .form-radio {
    margin-right: ${rem('15px')};
  }
  .wrapper-flex {
    display: flex;
  }
`;

export { StyledDataFormUser, StyledFormModal, StyledCheckbox };
